<script setup>

import {defineEmits, ref} from 'vue';

const charged = ref(false);

const emit = defineEmits(['click'])

function clickFun(e) {
    if(charged.value){
        emit('click');
        charged.value = false;
    }else{
        charged.value = true;
    }

}

</script>


<template>
    <button @click.stop="clickFun">
        <Transition name = "fade" mode="out-in">
            <span v-if="charged"><slot name="Charged" ></slot></span>
            <span v-else><slot name="UnCharged"></slot></span>        
        </Transition>
    </button>
</template>


<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
</style>